// extracted by mini-css-extract-plugin
export default {"phoneInputOuter":"phoneInput_phoneInputOuter__5JTaY"};